import React, { useState } from 'react';
import { Link as RouterLink } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import { Box, IconButton, MobileStepper, Typography } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { AppButton } from '../components/InputComponents';
import IntroStep from './IntroStep.component'

import useStyles from "./Introduction.style";

const Introduction = () => {
    const classes = useStyles();

    const [activeStep, setActiveStep] = useState(0);

    const steps = 3;

    const handleStepChange = step => {
        setActiveStep(step);
    };

    const handleArrowNavigation = direction => () => {
        direction === 'back' ? setActiveStep(activeStep - 1) : setActiveStep(activeStep + 1);
    };

    return (
        <>
            <Box
                style={{
                    height: '100vh',
                    width: '100vw',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255,255,255,0)',
                    padding: 10,
                }}
            >
                <Box style={{ zIndex: 1 }}>
                    {activeStep > 0 &&
                        <IconButton onClick={handleArrowNavigation('back')}>
                            <ArrowBackIosIcon />
                        </IconButton>
                    }
                </Box>
                <Box style={{ flexGrow: 1 }}>

                </Box>
                <Box style={{ zIndex: 1 }}>
                    {activeStep < steps - 1 &&
                        <IconButton onClick={handleArrowNavigation('forward')}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                    }
                </Box>
            </Box>
            <SwipeableViews
                containerStyle={{ height: 'calc(100vh - 50px)' }}
                index={activeStep}
                onChangeIndex={handleStepChange}
            >
                <IntroStep
                    text='Most women let their reproductive life happen to them'
                />
                <IntroStep
                    text='At RepLI we believe you should make your reproductive life happen for you'
                />
                <IntroStep
                    text={<>Reproductive Life by Design<br />Not Chance</>}
                >
                    <Box className={classes.buttonContainer}>
                        <Typography color="secondary" variant="h6">
                            PACK YOUR BAGS
                        </Typography>
                        <AppButton
                            variant="contained"
                            color="secondary"
                            fullWidth
                            size="large"
                            component={RouterLink}
                            to="/app/dashboard"
                        >
                            Let's start the journey
                        </AppButton>
                    </Box>
                </IntroStep>
            </SwipeableViews>
            <Box className={classes.stepperContainer}>
                <MobileStepper
                    variant="dots"
                    position="bottom"
                    steps={steps}
                    activeStep={activeStep}
                    nextButton={
                        <div style={{ height: 50 }}>
                        </div>
                    }
                    backButton={
                        <div>
                        </div>
                    }
                />
            </Box>
        </>
    );
};

export default Introduction;
